import { IContactTypes } from "./contact-types";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { EntityFilters } from "src/app/models/contacts/entity-filters";
import { IFilters } from "src/app/interfaces/ifilters";

@Injectable()
export class FreightCompanyType implements IContactTypes {
    public getFilters(): Observable<IFilters> {
    return of(new EntityFilters(3));
}
}